module.exports = __webpack_public_path__ + "static/media/LOOK4U.c043bd9e.svg";